/**
 * Hides anonymous reviews in Reviews.io Polaris widget.
 * Only loaded on AppLovin PDP (product.applovin template).
 * Supports #ReviewsWidgetABTEST and #ReviewsWidget.
 */
(function () {
  var widgetIds = ['ReviewsWidgetABTEST', 'ReviewsWidget'];
  var anonymousName = 'Anonym';

  function hideAnonymousReviews(wrapper) {
    if (!wrapper) return;

    var authorSelectors = '.c-meta__authorName, .cssVar-authorName, [class*="authorName"]';
    var authorEls = wrapper.querySelectorAll(authorSelectors);

    authorEls.forEach(function (el) {
      var name = (el.textContent || '').trim();
      if (name !== anonymousName) return;

      var card =
        el.closest('.R-ContentList__item') ||
        el.closest('.u-marginBottom--md') ||
        el.closest('[class*="Review"]') ||
        el.closest('article') ||
        el.closest('[class*="Item"]');

      if (!card || card === wrapper) {
        card = null;
        var p = el.parentElement;
        var depth = 0;
        while (p && p !== wrapper && depth < 15) {
          if (p.tagName === 'ARTICLE') {
            card = p;
            break;
          }
          if (p.classList && p.classList.length) {
            var c = p.className || '';
            if (/R-ContentList__item|Review|Item|Card|marginBottom|review-item|ElementsWidget__item/i.test(c)) {
              card = p;
              break;
            }
          }
          var parent = p.parentElement;
          if (parent && parent !== wrapper && parent.children.length >= 3 && depth >= 3) {
            card = p;
            break;
          }
          if (depth >= 6 && p.children.length >= 2) {
            card = p;
            break;
          }
          p = parent;
          depth = depth + 1;
        }
      }

      if (card && card !== wrapper) {
        card.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function runWhenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runWhenReady);
      return;
    }

    widgetIds.forEach(function (id) {
      var wrapper = document.getElementById(id);
      if (!wrapper) return;
      hideAnonymousReviews(wrapper);
      if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function () {
          hideAnonymousReviews(wrapper);
        });
        observer.observe(wrapper, { childList: true, subtree: true });
      }
    });
  }

  runWhenReady();
})();
